class SiteNavigationNone
    extends SiteNavigation
{
    private _isActive: boolean;

    constructor(site: Site) {
        super();
        this._isActive = false;
    }
    
    isActive() {
        return this._isActive;
    }
    makeActive() {
        this._isActive = true;
        return this;
    }
    makeInactive() {
        this._isActive = false;
        return this;
    }
}